// UI_STANDARDS.md B0/B7: status = colored dot + tint pill. NEVER a solid-red block, even for
// "Overdue"/"Suspended" — this component is the single place that renders the status system, so
// B0 can't be violated by accident elsewhere. Extended for UX-CP-01's gym-lifecycle statuses
// (trial = calm accent tint, read_only/suspended reuse the Overdue tint per the prompt's own
// "suspended = dot+tint, never solid-red" rule — SCHEMA.md's license.state has no separate
// "suspended" value, read_only IS the Control-Plane's "Suspended").
const VARIANTS = {
  active: "active", trial: "trial", expiring: "expiring",
  overdue: "overdue", suspended: "overdue", read_only: "overdue", grace: "expiring",
};
const DEFAULT_LABELS = {
  active: "Active", trial: "Trial", expiring: "Expiring", overdue: "Overdue",
  suspended: "Suspended", read_only: "Suspended", grace: "Grace period",
};

export function StatusPill({ status, label, testId }) {
  const variant = VARIANTS[status] || "active";
  const text = label || DEFAULT_LABELS[status] || DEFAULT_LABELS[variant];
  return (
    <span className={`status-pill ${variant}`} data-testid={testId}>
      <span className="dot" />
      {text}
    </span>
  );
}
